import React from 'react';
import Colors from '../../../utils/color';

/**
 * The `×N` chip agents learned on the repeated-slot panel (bagel dozens), shared
 * so the modifier-count stepper (HITL-1753) reads as the same control rather
 * than a look-alike. Matches `ModGroupRow.countChip` value for value.
 */
export const COUNT_CHIP_STYLE: React.CSSProperties = {
  flexShrink: 0,
  fontSize: '10px',
  fontWeight: 700,
  lineHeight: '14px',
  padding: '0 4px',
  borderRadius: 7,
  backgroundColor: Colors.alto,
  color: Colors.daintree,
};
